import axios from "axios";
import wcaBaseUrl from "./wca.server";
import { logout } from "../reducers/authSlice";

export const axiosWcaInstance = axios.create({
  baseURL: wcaBaseUrl,
  headers: {
    Accept: "*/*",
    "Content-Type": "application/json",
  },
});

// ✅ Request Interceptor
export const setupWcaRequestInterceptor = () => {
  axiosWcaInstance.interceptors.request.use(
    (config) => {
      const token = localStorage.getItem("token");
      const sessionID = localStorage.getItem("sessionID");
      const companyId = localStorage.getItem("companyId");

      if (token) {
        config.headers["authorization"] = token;
      }
      if (sessionID) {
        config.headers["sessionid"] = sessionID;
      }

      // Always append cmpId in query params
      if (companyId) {
        config.params = {
          ...config.params,
          cmpId: companyId,
        };

        // For non-GET requests, add companyId in body too
        if (config.method !== "get") {
          config.data = {
            ...(config.data || {}),
            companyId,
          };
        }
      }

      return config;
    },
    (error) => {
      console.error("WCA Request Error:", error);
      return Promise.reject(error);
    }
  );
};

axiosWcaInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      logout();
      localStorage.removeItem("token");
      localStorage.removeItem("sessionID");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export default axiosWcaInstance;
